/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ConversationDestroyPathParams, ConversationDestroyResponse } from '../types/ConversationDestroy'

/**
 * DELETE /ai/conversations/:conversationId
 * @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::destroy
 */
export async function conversationDestroy(
	conversationId: ConversationDestroyPathParams['conversationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ConversationDestroyResponse>> {
	return axiosInstance.delete(`/ai/conversations/${conversationId}`, config)
}
